import React, { useState, useEffect, useRef } from "react";
import { Button, message, Spin, Avatar, Steps } from "antd";
import _ from "lodash";
import $axios from "../services/axios";
import { useLocation, useHistory } from "react-router-dom";
import "@goongmaps/goong-js/dist/goong-js.css";
import { EStatusTrip } from "../helpers/const";
import { callPhoneNumber } from "../helpers/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faNoteSticky } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

const Tracking = () => {
  const location = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const queryParams = new URLSearchParams(location.search);
  //new
  const [bookingInfo, setBookingInfo] = useState(null);
  const [force, forceUpdate] = useState(false);
  const stopPollingRef = useRef(false);
  const intervalIdRef = useRef(null);

  useEffect(() => {
    if (queryParams.get("bookingId")) {
      pollUntilTripStatus(2000, queryParams.get("bookingId"));
    } else {
      message.error("Không tìm thấy dữ liệu chuyến đi!");
      window.location.href = `/booking-driver`;
    }
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => {
      stopPollingTripStatus(); // cleanup khi unmount
    };
  }, []);

  useEffect(() => {
    if (bookingInfo && bookingInfo.statusBooking) {
      if (
        bookingInfo.statusBooking === EStatusTrip.CANCELED ||
        bookingInfo.statusBooking === EStatusTrip.REJECTED
      ) {
        message.error("Chuyến đi đã bị hủy!");
        stopPollingTripStatus();
      } else if (bookingInfo.statusBooking === EStatusTrip.COMPLETED) {
        message.success("Chuyến đi đã hoàn thành!");
        stopPollingTripStatus();
      }
    }
  }, [bookingInfo]);

  // Gọi tài xế
  const onCallDriver = () => {
    if (bookingInfo?.driver.phoneNumber) {
      callPhoneNumber(bookingInfo.driver.phoneNumber);
    }
  };

  const stopPollingTripStatus = () => {
    stopPollingRef.current = true;
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
      intervalIdRef.current = null;
    }
    forceUpdate((prev) => !prev);
  };

  const pollUntilTripStatus = (delay = 2000, resBookingId) => {
    intervalIdRef.current = setInterval(async () => {
      if (stopPollingRef.current) return;
      try {
        const resBooking = await $axios.$get(
          `/api/v1/say-car/find-book-by-id?tripId=${resBookingId}`
        );
        setBookingInfo(resBooking.data?.data);
      } catch (err) {
        console.error("Polling failed:", err);
        if (!bookingInfo) {
          message.error("Không tìm thấy dữ liệu chuyến đi!");
          stopPollingTripStatus();
          window.location.href = "/booking-driver";
        }
      }
    }, delay);
  };
  return (
    <Spin tip="Tải dữ liệu" size="large" spinning={loading}>
      <div className="bg-blue-200 min-h-screen">
        <div
          className="w-full h-[300px] absolute"
          style={{
            backgroundImage: `url(/images/bg-form.png)`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
          }}
        ></div>
        {bookingInfo && (
          <div className="absolute top-[150px] w-full">
            <div
              className="mt-2 w-full p-4 bg-white mb-4"
              style={{
                boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.25)",
              }}
            >
              <div>
                {bookingInfo.statusBooking === EStatusTrip.ACCEPTED && (
                  <span className="text-primary font-semibold text-[16px]">
                    Đã kết nối với tài xế
                  </span>
                )}
                {(bookingInfo.statusBooking === EStatusTrip.CANCELED ||
                  bookingInfo.statusBooking === EStatusTrip.REJECTED) && (
                  <span className="text-red-700 font-semibold text-[16px]">
                    Chuyến đi đã bị hủy
                  </span>
                )}
                {bookingInfo.statusBooking === EStatusTrip.ON_TRIP && (
                  <span className="text-yellow-600 font-semibold text-[16px]">
                    Đang di chuyển
                  </span>
                )}
                {bookingInfo.statusBooking === EStatusTrip.COMPLETED && (
                  <span className="text-green-600 font-semibold text-[16px]">
                    Chuyến đi đã hoàn thành
                  </span>
                )}
              </div>
            </div>
            <div
              className="mt-2 w-full p-4 bg-white mb-4"
              style={{
                boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.25)",
              }}
            >
              <div className="text-[16px] text-primary font-semibold mb-3">
                Thông tin tài xế
              </div>
              <div className="flex flex-col">
                <div className="flex gap-4 items-center justify-between w-full">
                  <Avatar
                    size={64}
                    src={
                      "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                    }
                    onError={() => {
                      return false;
                    }}
                  />
                  <div className="flex flex-col gap-1 flex-1 text-left">
                    <div className="text-[14px] font-medium text-primary">
                      {bookingInfo?.driverName}
                    </div>
                    <div>
                      {bookingInfo?.driverPhoneNumber.replace("+84", "0")}
                    </div>
                  </div>
                  <div className="flex flex-col gap-1 items-center">
                    <Button
                      onClick={() => onCallDriver()}
                      variant="solid"
                      className="bg-primary max-w-[58px]"
                      type="primary"
                    >
                      <FontAwesomeIcon
                        icon={faPhone}
                        className="text-white text-[16px]"
                      />
                    </Button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="mt-2 w-full p-4 bg-white mb-4"
              style={{
                boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.25)",
              }}
            >
              <div className="text-[16px] font-semibold mb-3 text-primary">
                Mã chuyến đi: {bookingInfo.shortCode}
              </div>
              <div className="text-[14px] font-semibold mb-3">
                Khoảng cách ước tính: {(bookingInfo.distance / 1000).toFixed(1)}
                km
              </div>
              <Steps
                className="custom-icon-steps"
                progressDot={(iconDot, { index, status }) => (
                  <div className="custom-dot">
                    {index === 0 ? (
                      <svg
                        className="text-primary w-[14px]"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.49997 10.3847C9.0931 10.3847 10.3846 9.09322 10.3846 7.50009C10.3846 5.90696 9.0931 4.61548 7.49997 4.61548C5.90684 4.61548 4.61536 5.90696 4.61536 7.50009C4.61536 9.09322 5.90684 10.3847 7.49997 10.3847Z"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                        <circle
                          cx="7.5"
                          cy="7.5"
                          r="6.75"
                          stroke="currentColor"
                          stroke-width="1.5"
                        />
                      </svg>
                    ) : (
                      <svg
                        className="text-primary w-[14px]"
                        width="16"
                        height="20"
                        viewBox="0 0 16 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.875 7.52969C14.875 12.1875 8 19.0625 8 19.0625C8 19.0625 1.125 12.1875 1.125 7.52969C1.125 3.16031 4.67781 0.625 8 0.625C11.3222 0.625 14.875 3.16031 14.875 7.52969Z"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                        <path
                          d="M8 10C9.38071 10 10.5 8.88071 10.5 7.5C10.5 6.11929 9.38071 5 8 5C6.61929 5 5.5 6.11929 5.5 7.5C5.5 8.88071 6.61929 10 8 10Z"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                      </svg>
                    )}
                  </div>
                )}
                current={4}
                items={[
                  {
                    description: "Điểm đi",
                    title: bookingInfo.fromLocation,
                  },
                  ...bookingInfo.toLocations.map((place, index) => ({
                    description: `Điểm đến ${index + 1}`,
                    title: place,
                  })),
                ]}
              />
              {bookingInfo.note && (
                <div className="flex gap-2 my-4">
                  <FontAwesomeIcon
                    icon={faNoteSticky}
                    className="text-primary text-[16px]"
                  />
                  <div className="text-[14px] font-medium">
                    Ghi chú: {bookingInfo.note}
                  </div>
                </div>
              )}
              <div className="flex justify-between p-4 bg-gray-50 rounded-md">
                <div className="text-[16px] font-semibold">Tổng tiền</div>

                <div className="text-[16px] text-green-600 font-semibold">
                  {bookingInfo.totalAmount.toLocaleString("vi-VN")} VNĐ
                </div>
              </div>

              {(bookingInfo.statusBooking === EStatusTrip.CANCELED ||
                bookingInfo.statusBooking === EStatusTrip.COMPLETED ||
                bookingInfo.statusBooking === EStatusTrip.REJECTED) && (
                <Button
                  className=" w-full mt-4"
                  size="large"
                  variant="solid"
                  color="primary"
                  onClick={() => {
                    window.location.href = "/booking-driver";
                  }}
                >
                  <span className="text-[16px] font-bold text-white">
                    Đặt chuyến khác
                  </span>
                </Button>
              )}
            </div>
          </div>
        )}
      </div>
    </Spin>
  );
};

export default Tracking;
